import axios from 'axios';
import log from 'chameleon/ui-stack/utilities/log';
import { reportsClient } from 'legacy-src/utility/GraphqlClients';
import { curriculumCategories as curriculumCategoriesQuery } from 'legacy-src/queries_reporting';
import { toast } from 'chameleon/ui-stack/ui/toast';
import {
  GeneratePracticeQuiz,
  AutoGenerateQuiz,
  AssessmentAssignedInfoQuery,
} from 'chameleon/legacy/src/queries';

export const getTrendData = async (params) => {
  try {
    const response = await axios.get(
      `${FYM_BACKEND_REPORTING_URL}/api/scores-per-tag-category`,
      { params },
    );
    return response.data.__root__;
  } catch (e) {
    log('error', e);
    toast('Could not get scores, an error occurred.');
    return [];
  }
};

export const getCategories = async (master_subject_id) => {
  try {
    const {
      data: { curriculumCategories },
    } = await reportsClient.query({
      query: curriculumCategoriesQuery,
      fetchPolicy: 'network-only',
      variables: { masterSubjectId: Number.parseInt(master_subject_id, 10) },
    });
    return curriculumCategories;
  } catch (e) {
    log('error', e);
    toast('Could not get categories, an error occurred.');
  }
};

export const getStudentData = async (params) => {
  try {
    const response = await axios.get(
      `${FYM_BACKEND_REPORTING_URL}/api/scores-per-student-per-tag`,
      { params },
    );
    return response.data.__root__;
  } catch (e) {
    log('error', e);
    return [];
  }
};

export const getTagCategoriesPracticeExam = async ({
  subjectId,
  educationPeriod,
}) => {
  try {
    const response = await axios.get(
      `${FYM_BACKEND_URL}/tagging/api/subject/${subjectId}/categories?minimal_fields_only=true&educationPeriod=${educationPeriod}&flatten_trees=true`,
    );
    return response.data.above_fold
      .find(({ label }) => label === 'Assessment Purpose and Source')
      .tags.find(({ label }) => label === 'AP Practice Exam')
      .tags.filter(({ label }) => label !== 'Previous Practice Question');
  } catch (error) {
    log('error', error);
    return [];
  }
};

export const getDistrictSchoolStudentHierarchy = async ({
  subjectId,
  educationPeriod,
}) => {
  try {
    const response = await axios.get(
      `${FYM_BACKEND_REPORTING_URL}/api/hierarchy`,
      {
        requestId: 'reports-hierarchy',
        params: {
          subject_id: subjectId,
          education_period: educationPeriod,
        },
      },
    );
    return response?.data;
  } catch (error) {
    log('error', error);
    return {};
  }
};

export const generatePracticeQuiz = async (client, generatePracticeParams) => {
  try {
    const {
      masterSubjectId,
      tagCategoryId,
      tagsPerformance,
      allowedPracticeExams,
      mcqNum,
      frqNum,
      exclusionDays,
    } = generatePracticeParams;
    const response = await client.query({
      query: GeneratePracticeQuiz,
      variables: {
        masterSubjectId,
        tagCategoryId,
        tagsPerformance,
        allowedPracticeExams,
        mcqNum,
        frqNum,
        excludeInterval: exclusionDays,
      },
    });
    return response.data.generatePracticeQuiz;
  } catch (error) {
    log('error', error);
    return {};
  }
};

export const autoGenerateQuiz = async (
  client,
  title,
  libraryId,
  questionIds,
) => {
  try {
    const response = await client.mutate({
      mutation: AutoGenerateQuiz,
      variables: {
        title,
        libraryId,
        content: JSON.stringify({}),
        autoCreateContent: true,
        questionIds,
      },
    });
    return response.data.createQuiz;
  } catch (error) {
    log('error', error);
    return {};
  }
};

export const getAssessmentAssignedInfo = async (
  assessmentId,
  educationPeriod,
) => {
  try {
    const response = await reportsClient.query({
      query: AssessmentAssignedInfoQuery,
      variables: {
        assessmentId,
        educationPeriod,
      },
    });
    return response.data.assessmentAssignedInfo;
  } catch (error) {
    log('error', error);
    return [];
  }
};
